import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { useSegments } from 'expo-router';

const ROUTE_GROUP_SEGMENT = /^\(.+\)$/;

export const getDatadogRoutePath = (segments: string[]) => {
  const routeSegments = segments.filter(
    segment => Boolean(segment) && !ROUTE_GROUP_SEGMENT.test(segment) && segment !== 'index'
  );

  return routeSegments.length ? `/${routeSegments.join('/')}` : '/';
};

const getDatadogRouteName = (routePath: string) => (routePath === '/' ? 'Home' : routePath);

export const useRumRouteView = () => {
  const segments = useSegments();
  const routeSegmentsKey = segments.join('/');

  useEffect(() => {
    const routeSegments = routeSegmentsKey ? routeSegmentsKey.split('/') : [];
    const routePath = getDatadogRoutePath(routeSegments);

    datadogRum.startView({
      name: getDatadogRouteName(routePath),
      context: {
        routePath,
        routeSegments,
      },
    });
  }, [routeSegmentsKey]);
};
